export enum TwoFactorMethod {
  AuthenticatorApp = 0,
  Email = 1,
}
